import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'uxg-skeleton-text',
  templateUrl: './skeleton-text.component.html',
  styleUrls: ['./skeleton-text.component.scss']
})
export class SkeletonTextComponent implements OnInit, OnDestroy {
  ngOnInit() {}
  ngOnDestroy() {}
}
